import { Pipe, PipeTransform } from '@angular/core';
import { addSpacesToTypeName } from '../split-enum-strings/add-spaces.pipe';

@Pipe({
    name: 'agentStatus',
    pure: false,
    standalone: false
})
export class AgentStatusPipe implements PipeTransform {
   transform(status: string, endWrapUpTime?: string | Date): string {
      if (status === 'Available') {
         if (endWrapUpTime) {
            const wrapUpEnd = new Date(endWrapUpTime);
            const now = new Date();

            if (isNaN(wrapUpEnd.getTime())) {
               return 'Available';
            }

            if (wrapUpEnd > now) {
               return 'Wrap Up';
            }
         }
         return 'Available';
      }
      return addSpacesToTypeName(status);
   }
}
